export enum CsasDtoCommonDocumentState {
  PreparingDocument = 'PreparingDocument',
  DocumentPrepared = 'DocumentPrepared',
  DocumentProcessed = 'DocumentProcessed',
  ProcessedDocumentRead = 'ProcessedDocumentRead',
  DocumentDisabled = 'DocumentDisabled',
}

export enum CsasDtoSignDocumentState {
  DocumentSignStart = 'DocumentSignStart',
  DocumentEdit = 'DocumentEdit',
  DocumentEditEnabled = 'DocumentEditEnabled',
  InsertingSignature = 'InsertingSignature',
  Finalized = 'Finalized',
}

export enum CsasDtoConfirmDocumentState {
  DocumentConfirmStart = 'DocumentConfirmStart',
  PreparedDocumentRead = 'PreparedDocumentRead',
}

export enum CsasDtoReadDocumentState {
  DocumentReadStart = 'DocumentReadStart',
}

export type CsasDocumentState =
  | CsasDtoCommonDocumentState
  | CsasDtoSignDocumentState
  | CsasDtoConfirmDocumentState
  | CsasDtoReadDocumentState;
